<template>
  <require from="controls/bs-form-input"></require>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <div class="form-row">
    <div class="col-md-6 order-md-0">
      <bs-form-input type="text" label="Role" value.bind="model.jobTitle" disabled="true"></bs-form-input>
    </div>
    <div class="col-md-6 order-md-1">
      <bs-form-input type="text" label="BP Email" value.bind="model.email" disabled="true"></bs-form-input>
    </div>
    <div class="col-md-6 order-md-3">
      <bs-form-input type="text" label="Countries Email" placeholder.bind="model.email" value.bind="model.countriesContactEmail & validate" maxlength="100"></bs-form-input>
    </div>
    <div class="col-md-6 order-md-1">
      <bs-form-input type="text" label="Phone" value.bind="model.mobilePhone" disabled="true"></bs-form-input>
    </div>
  </div>
  <div class="form-row">
    <div class="col">
      <div class="sc-buttons-container text-nowrap" style="text-align: right; margin-left: auto;">
        <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
          <i class="fas fa-paper-plane"></i>Save Changes
        </button>
        <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
